import createLogger from 'vuex/dist/logger'
import Vue from 'vue'
import Vuex from 'vuex'
// import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

Vue.use(Vuex)

// Require in a base component context
const requireComponent = require.context(
  './stores/', false, /[\w-]\.js$/
)
const modules = {}
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  modules[componentName] = componentConfig.default || componentConfig
})
const debug = ['production', 'test'].indexOf(process.env.NODE_ENV) === -1

export default new Vuex.Store({
  modules,
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store.js